import React, { FC } from 'react';
import { Switch, Redirect, RouteComponentProps } from 'react-router-dom';
import { NOT_FOUND_ERROR_PAGE_PATH } from 'src/app/common/constants';
import PruRoute from 'src/app/common/components/PruRoute';
import { PULSELEADS_BASE_PATH } from '../../../constants';
import { PULSELEADS_STRAIGHT_THROUGH_PATH, PULSELEADS_STRAIGHT_THROUGH_CHANNEL_CAMPAIGN_PATH } from '../constants';
import ParamsProvider from 'src/app/common/components/ParamsProvider';
import ChannelCampaignListingPage, { channelCampaignFilterKeys } from './List/ChannelCampaignListingPage';
import ChannelCampaignDetailPage from './Form/ChannelCampaignDetailPage';

export const channelCampaignPath = `${PULSELEADS_BASE_PATH}${PULSELEADS_STRAIGHT_THROUGH_PATH}${PULSELEADS_STRAIGHT_THROUGH_CHANNEL_CAMPAIGN_PATH}`;

const ChannelCampaignRoutes: FC<RouteComponentProps> = () => {
  return (
    <Switch>
      <Redirect exact from={channelCampaignPath} to={`${channelCampaignPath}/list`} />
      <PruRoute
        exact
        path={`${channelCampaignPath}/list`}
        render={(props) => (
          <ParamsProvider {...props} acceptKeys={channelCampaignFilterKeys}>
            <ChannelCampaignListingPage />
          </ParamsProvider>
        )}
      />
      <PruRoute exact path={`${channelCampaignPath}/create`} component={ChannelCampaignDetailPage} />
      <PruRoute exact path={`${channelCampaignPath}/edit/:id`} component={ChannelCampaignDetailPage} />
      <Redirect to={NOT_FOUND_ERROR_PAGE_PATH} />
    </Switch>
  );
};

export default ChannelCampaignRoutes;
